"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _layout = require("../../layout");

var _text = require("../../text");

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

var DateMarkerLegendEntry = function DateMarkerLegendEntry(_ref) {
  var markerExample = _ref.markerExample,
      descriptionText = _ref.descriptionText;
  return (0, _core.jsx)(_helperComponents.DateMarkerLegendLi, null, (0, _core.jsx)(_layout.Row, {
    gridGap: "S200",
    alignItems: "center"
  }, markerExample, (0, _core.jsx)(_text.Text, {
    fontSize: "T100",
    color: "neutral70"
  }, descriptionText)));
};

DateMarkerLegendEntry.displayName = 'DateMarkerLegendEntry';
var _default = DateMarkerLegendEntry;
exports.default = _default;